import React, { Fragment } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Tooltip from './Tooltip';

const emptyFunc = () => {};

const RadioButton = ({
  name,
  id,
  preElement,
  value,
  text,
  checked,
  textOnly,
  subText,
  subElement,
  onChange = emptyFunc,
  tooltip,
  tooltipConfig,
  disabled = false,
}) => (
  <Fragment key={id}>
    {preElement && preElement}
    <div
      className={cx('radio-summary align-self-center mr-sm', { active: checked })}
      data-testid={`radio-button-${value}`}
    >
      <input
        className="radio-input"
        type="radio"
        name={name}
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={() => onChange(value)}
      />
      <Tooltip
        content={tooltipConfig ? tooltipConfig.text : tooltip}
        position={tooltipConfig && tooltipConfig.position}
      >
        {/* eslint-disable-next-line */}
        <label
          className={cx('radio-label d-flex align-items-center text-bold text-xxs', { disabled })}
          htmlFor={id}
        >
          {!textOnly && <div className="radio-button d-flex mr-xs flex-no-shrink" />}
          <span>{text}</span>
        </label>
      </Tooltip>
      {subText && (
        <p className="text-xxxs" style={{ fontSize: 9, marginLeft: -2 }}>
          ({subText})
        </p>
      )}
      {subElement && subElement}
    </div>
  </Fragment>
);

RadioButton.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string.isRequired,
  preElement: PropTypes.element,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]).isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  checked: PropTypes.bool.isRequired,
  textOnly: PropTypes.bool,
  subText: PropTypes.string,
  subElement: PropTypes.element,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipConfig: PropTypes.object,
};

export default RadioButton;
